export default __webpack_public_path__ + "static/HelveticaNeue-Light-c6c8e62b1774e619ad44a2d57c034dd0.woff";